import React from 'react';
import Loading from '~/components/Loading';
import ErrorMessage from '~/components/ErrorMessage';
import useCustomQuestionEditor from '~/components/customquestions/useCustomQuestionEditor';
import { EditorColumns } from '~/components/customquestions/CustomQuestionEditorParts';

/**
 * The custom question editor in the form designer's full screen modal, opened
 *  from the Add Element panel. The same columns as the page
 *  (CustomQuestionEditor), under a fixed heading.
 */
const CustomQuestionModalEditor = options => {
    const editor = useCustomQuestionEditor(options);
    const { draft, errors } = editor;

    if (!draft) {
        return <Loading />;
    }

    return (
        <div>
            {/* The same global h1 style and spacing as the page's PageHeading.
                pr-10 keeps it clear of the modal's close button */}
            <h1 className="mb-4 pr-10">New Custom Question</h1>

            <ErrorMessage errors={errors} />

            <EditorColumns editor={editor} />
        </div>
    );
};

export default CustomQuestionModalEditor;
